<template>
    <div class="infoArea">
        <div class="briefInfo">
            <div class="briefTit">讲师介绍</div>
            <ul class="briefLis">
                <template v-for="(item, index) in briefArray">
                    <li :key="index">
                        <img :src="pic + item.expertAvatar" draggable="false" style="width: 97px;height: auto;"/>
                        <div class="msg">
                            <p>{{ item.expertName }}</p>
                            <p>{{ item.expertHospital }}</p>
                            <p>{{ item.expertIntroduction }}</p>
                        </div>
                    </li>
                </template>
            </ul>
        </div>
        <div class="hotVideo">
            <img src="../../assets/img/vip_header.png" class="hotImg" draggable="false" />
            <div class="hotTit">大家都在看</div>
            <ul class="hot-lis">
                <template v-for="(item, index) in hotList">
                    <li :key="index" @click="sendParam(item.gid)">
                        <img :src="pic + item.avatar" draggable="false" />
                        <div class="wrap">
                            <p>{{ item.title }}</p>
                            <div>
                                <img src="../../assets/img/play.png" draggable="false" />
                                {{ item.watchNum }}
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "InfoArea",
    props: ["briefArray"],
    data() {
        return {
            hotList: [],
            pic: "https://www.orthoday.com/SDpic/common/picSelect?gid="
        };
    },
    mounted() {
        this.getHotList();
    },
    methods: {
        getHotList() {
            let params = {
                category: 1,
                charge: 1,
                keyword: "",
                pageNum: 1,
                rank: "updateTime",
                type: ""
            };
            this.$axios
                .post("/web/course/queryCourseList", this.$qs.stringify(params))
                .then(res => {
                    let data = res.data;
                    if (data.code == "1") {
                        let dtArr = data.result_data.courseList;
                        this.hotList = dtArr.splice(0, 4);
                    } else {
                        this.$message.error(data.message);
                    }
                })
                .catch(err => {
                });
        },
        sendParam(gid) {            
            this.$emit("transfer", gid);
        }
    }
};
</script>

<style scoped src="../../assets/css/info-area.css"></style>
